module.exports = __webpack_public_path__ + "img/banner01.8009f226.jpg";